module.exports = __webpack_public_path__ + "static/media/PeaceOdiase.f0b7e565.png";